import { z } from "zod"

export const UserRolesSchema = z.object({
  roles: z
    .array(
      z.object({
        roleId: z.string().min(1),
        name: z.string().min(1),
      })
    )
    .min(1, "At least one role is required"),
})

export type UserRolesSchemaType = z.infer<typeof UserRolesSchema>
